import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { SortDirection, CursorMode } from './Enums'
/**
* Class FavoritesProductsListGetRequestQuery
*  Query params for operation "FavoritesProductsListGet"
*/
export class FavoritesProductsListGetRequestQuery extends ActiveModel {

/**
  * ['Filter.FavCreatedBefore']
  * Фильтр по дате добавления записи в избранное (не позднее, не включая)<br>
  */
  @ActiveField()
  ['Filter.FavCreatedBefore']?: string


/**
  * ['Filter.FavCreatedAfter']
  * Фильтр по дате добавления записи в избранное (не раньше, включительно)<br>
  */
  @ActiveField()
  ['Filter.FavCreatedAfter']?: string


/**
  * ['Filter.CreatedBefore']
  * Фильтр по дате создания (не позднее, не включая)<br>
  */
  @ActiveField()
  ['Filter.CreatedBefore']?: string


/**
  * ['Filter.CreatedAfter']
  * Фильтр по дате создания (не раньше, включительно)<br>
  */
  @ActiveField()
  ['Filter.CreatedAfter']?: string


  /**
  * ['Filter.CategoryId']
  * Фильтр по идентификатору категории<br>  */
  @ActiveField()
  ['Filter.CategoryId']?: number


  /**
  * ['Filter.CollectionId']
  * Состав подборки (Manual или Rule) на канале витрины<br>  */
  @ActiveField()
  ['Filter.CollectionId']?: number


  /**
  * ['Filter.OutOfStock']
  * Если true, то показывать товары, которых нет в наличии<br>  */
  @ActiveField()
  ['Filter.OutOfStock']?: boolean


  /**
  * ['Filter.Attrs']
  * Фильтр по значениям атрибута, где: <br><br>ключ: идентификатор атрибута; <br><br>значение: список значений для фильтрации. <br><br>Пример для использования в query-части запроса:<br>`Filter.Attrs[0][0].min=10&Filter.Attrs[0][0].max=20&Filter.Attrs[0][1].min=30&Filter.Attrs[0][1].max=50&Filter.Attrs[0][2].val=100&Filter.Attrs[10][0].val=100`  */
  @ActiveField(() => undefined)
  ['Filter.Attrs']?: Record<string, array>


/**
  * Query
  * Поисковый запрос<br>
  */
  @ActiveField()
  Query?: string


  /**
  * Limit
  * Кол-во элементов в результате. <br><br>Если значение меньше 1, то вернуть все элементы<br>  */
  @ActiveField()
  Limit?: number


/**
  * SortField
  * Поле для сортировки<br>
  */
  @ActiveField()
  SortField?: string


  /**
  * SortDirection
  * Направление сортировки<br>  */
  @ActiveField()
  SortDirection?: SortDirection


  /**
  * CursorMode
  * Режим курсора. Если значение указано, то необходимо<br>указывать Web.Core.Pagination.SortOptions.CursorField и Web.Core.Pagination.SortOptions.CursorId  */
  @ActiveField()
  CursorMode?: CursorMode


/**
  * CursorField
  * Значение Web.Core.Pagination.SortOptions.SortField первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorField?: string


/**
  * CursorId
  * Значение уникального ключа (чаще всего, но не обязательно, это id) первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorId?: string
}
